import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Outlet } from "react-router-dom";
import { fetchSettings } from "../../lib/api";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { MobileActionBar } from "./MobileActionBar";

export const Layout = () => {
  const { data: settings } = useQuery({ queryKey: ["settings"], queryFn: fetchSettings });
  return (
    <div className="min-h-screen bg-hb-black">
      <Navbar />
      <main className="pb-16 md:pb-0">
        <Outlet context={{ settings: settings || {} }} />
      </main>
      <Footer settings={settings} />
      <MobileActionBar settings={settings} />
    </div>
  );
};
